import { create } from 'zustand';

const useContentStore = create((set) => ({
	content: { errorContent: {}, pricingContent: {}, authenticationContent: {}, sharedContent: {} },
	authenticationContent: (state) => state.content.authenticationContent,
	pricingContent: (state) => state.content.pricingContent,
	sharedContent: (state) => state.content.sharedContent,
	setContent: (content) => set({ content })
}));

export { useContentStore };